import React, { useState, useEffect } from 'react';
import { merchAPI } from '../services/api';

const Merch = () => {
    const [merch, setMerch] = useState([]);
    const [lang, setLang] = useState('en');
    const [loading, setLoading] = useState(true);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        loadMerch();
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const checkMobile = () => {
        setIsMobile(window.innerWidth <= 768);
    };

    const loadMerch = async () => {
        try {
          const response = await merchAPI.getAll();
          setMerch(response.data);                 
          setLoading(false);
        } catch (error) {
          console.error('Error loading merch:', error);
          setLoading(false);
        }
    };

    if (loading) return <div style={styles.loading}>Cargando...</div>;

    return (
        <section style={isMobile ? {...styles.section, ...styles.sectionMobile} : styles.section}>
        <div style={styles.container}>
            <div style={styles.header}>
            <h2 style={isMobile ? {...styles.title, ...styles.titleMobile} : styles.title}>MERCH</h2>
            <button 
                onClick={() => setLang(lang === 'en' ? 'es' : 'en')}
                style={styles.langButton}
            >
                {lang === 'en' ? 'ES' : 'EN'}
            </button>
            </div>
            
            <div style={isMobile ? {...styles.grid, ...styles.gridMobile} : styles.grid}>
            {merch.map(item => (
                <div key={item.id} style={styles.card}>
                <div style={styles.cardImage}>
                    {item.imageUrl ? (
                    <img src={item.imageUrl} alt={item.nameEs} style={styles.image} />
                    ) : (
                    <div style={styles.placeholder}>Product Image</div>
                    )}
                </div>
                <div style={isMobile ? {...styles.cardContent, ...styles.cardContentMobile} : styles.cardContent}>
                    <h3 style={isMobile ? {...styles.cardTitle, ...styles.cardTitleMobile} : styles.cardTitle}>
                    {lang === 'es' ? item.nameEs : item.nameEn}
                    </h3>
                    {item[lang === 'en' ? 'descriptionEn' : 'descriptionEs'] && (
                    <p style={styles.cardDescription}>
                        {item[lang === 'en' ? 'descriptionEn' : 'descriptionEs']}
                    </p>
                    )}
                    {item.price && (
                    <p style={styles.cardPrice}>${item.price}</p>
                    )}
                </div>
                </div>
            ))}
            </div>
        </div>
        </section>
    );
};

const styles = {
    section: {
        minHeight: '100vh',
        background: '#000',
        padding: '100px 2rem 4rem',
        fontFamily: 'Roboto, sans-serif',
    },
    sectionMobile: {
        padding: '80px 1rem 2rem',
    },
    container: {
        maxWidth: '1200px',
        margin: '0 auto',
        fontFamily: 'Roboto, sans-serif',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '3rem',
        fontFamily: 'Roboto, sans-serif',
    },
    title: {
        fontSize: '3rem',
        color: '#fff',
        letterSpacing: '0.3rem',
        fontFamily: 'Roboto, sans-serif',
    },
    titleMobile: {
        fontSize: '2rem',
        letterSpacing: '0.15rem',
    },
    langButton: {
        padding: '0.5rem 1.5rem',
        background: '#222',
        border: 'none',
        color: '#fff',
        cursor: 'pointer',
        borderRadius: '5px',
        fontFamily: 'Roboto, sans-serif',
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '2rem',
        fontFamily: 'Roboto, sans-serif',
    },
    gridMobile: {
        gridTemplateColumns: '1fr',
        gap: '1.5rem',
    },
    card: {
        background: '#111',
        borderRadius: '10px',
        overflow: 'hidden',
        transition: 'transform 0.3s',
        fontFamily: 'Roboto, sans-serif',
    },
    cardImage: {
        width: '100%',
        background: '#222',
        fontFamily: 'Roboto, sans-serif',
    },
    image: {
        width: '100%',
        height: 'auto',
        display: 'block',
        fontFamily: 'Roboto, sans-serif',
    },
    placeholder: {
        color: '#666',
        fontFamily: 'Roboto, sans-serif',
    },
    cardContent: {
        padding: '1.5rem',
        fontFamily: 'Roboto, sans-serif',
    },
    cardContentMobile: {
        padding: '1rem',
    },
    cardTitle: {
        fontSize: '1.2rem',
        color: '#fff',
        marginBottom: '0.5rem',
        fontFamily: 'Roboto, sans-serif',
    },
    cardTitleMobile: {
        fontSize: '1.1rem',
    },
    cardDescription: {
        color: '#888',
        marginBottom: '1rem',
        fontFamily: 'Roboto, sans-serif',
    },
    cardPrice: {
        fontSize: '1.3rem',
        color: '#fff',
        fontWeight: 'bold',
        fontFamily: 'Roboto, sans-serif',
    },
    loading: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        fontSize: '1.5rem',
        fontFamily: 'Roboto, sans-serif',
    },
};

export default Merch;
